if (!customElements.get('vasenia-pdf-purchase')) {
  customElements.define('vasenia-pdf-purchase', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.button = this.querySelector('button');
      this.nativeButton = this.product?.querySelector('button[name="add"]');
      if (!this.nativeButton) return;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.sync = this.sync.bind(this);
      this.updateVisibility = this.updateVisibility.bind(this);
      this.onClick = () => {
        if (this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') return;
        this.button.disabled = true;
        this.nativeButton.click();
        this.sync();
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.nativeButton, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled','aria-disabled','class']});
      this.intersection = new IntersectionObserver(([entry]) => {this.nativeVisible = entry.isIntersecting; this.updateVisibility();}, {threshold: 0});
      this.intersection.observe(this.nativeButton);
      this.mobile.addEventListener('change', this.updateVisibility);
      this.sync();
    }
    sync() {
      this.button.textContent = this.nativeButton.textContent.replace(/\s+/g, ' ').trim();
      this.button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true' || this.nativeButton.classList.contains('loading');
      this.updateVisibility();
    }
    updateVisibility() {
      this.hidden = !this.mobile.matches || this.nativeVisible === true;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.mobile?.removeEventListener('change', this.updateVisibility);
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
